/* eslint-disable */

import {
  Flex,
  Box,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  Tfoot,
  useColorModeValue,
  Button,
  useToast,
  Link
} from '@chakra-ui/react';
import * as React from 'react';
import ReactPaginate from 'react-paginate'

import {
  createColumnHelper,
  flexRender,
  getCoreRowModel,
  getSortedRowModel,
  useReactTable,
} from '@tanstack/react-table';

// Custom components
import Card from 'components/card/Card';
import Menu from 'components/menu/MainMenu';
import { commonFetch } from '@/utils/util'

const items = [...Array(33).keys()];

const columnHelper = createColumnHelper();

// const columns = columnsDataCheck;
export default function ColumnTable(props) {
  const { tableData, onDetail } = props;
  const [sorting, setSorting] = React.useState([]);
  const textColor = useColorModeValue('secondaryGray.900', 'white');
  const borderColor = useColorModeValue('gray.200', 'whiteAlpha.100');
  const toast = useToast();

  let defaultData = tableData;
  const columns = [
    columnHelper.accessor('createdAt', {
      id: 'createdAt',
      header: () => (
        <Text
          justifyContent="space-between"
          align="center"
          fontSize={{ sm: '10px', lg: '12px' }}
          color="gray.400"
        >
          开票时间
        </Text>
      ),
      cell: (info) => (
        <Text>
          {(info.row.original.createdAt || '-')}
        </Text>
      ),
    }),
    columnHelper.accessor('type', {
      id: 'type',
      header: () => (
        <Text
          justifyContent="space-between"
          align="center"
          fontSize={{ sm: '10px', lg: '12px' }}
          color="gray.400"
        >
          发票类型
        </Text>
      ),
      cell: (info) => (
        <Text>
          { { 1: '普通发票', 2: '增值发票' }[info.row.original.type] || '-'}
        </Text>
      ),
    }),
    columnHelper.accessor('status', {
      id: 'status',
      header: () => (
        <Text
          justifyContent="space-between"
          align="center"
          fontSize={{ sm: '10px', lg: '12px' }}
          color="gray.400"
        >
          发票状态
        </Text>
      ),
      cell: (info) => (
        <Text>
          { { 0: '未开票', 1: '已开票', 2: '已作废' }[info.row.original.status] || '-'}
        </Text>
      ),
    }),
    columnHelper.accessor('amount', {
      id: 'amount',
      header: () => (
        <Text
          justifyContent="space-between"
          align="center"
          fontSize={{ sm: '10px', lg: '12px' }}
          color="gray.400"
        >
          开票金额
        </Text>
      ),
      cell: (info) => (
        <Text>
          ¥ {(info.row.original.amount || '0')}
        </Text>
      ),
    }),
    columnHelper.accessor('customerName', {
      id: 'customerName',
      header: () => (
        <Text
          justifyContent="space-between"
          align="center"
          fontSize={{ sm: '10px', lg: '12px' }}
          color="gray.400"
        >
          客户名称
        </Text>
      ),
      cell: (info) => (
        <Text>
          {info.row.original.customerName || '-'}
        </Text>
      ),
    }),
    columnHelper.accessor('customerTaxId', {
      id: 'customerTaxId',
      header: () => (
        <Text
          justifyContent="space-between"
          align="center"
          fontSize={{ sm: '10px', lg: '12px' }}
          color="gray.400"
        >
          客户税号
        </Text>
      ),
      cell: (info) => {
        // console.log(info, 'info')
        return (
          <Text>{info.row.original.customerTaxId || '-'}</Text>
        )
      }
    }),
    columnHelper.accessor('customerAddress', {
      id: 'customerAddress',
      header: () => (
        <Text
          justifyContent="space-between"
          align="center"
          fontSize={{ sm: '10px', lg: '12px' }}
          color="gray.400"
        >
          单位地址
        </Text>
      ),
      cell: (info) => (
        <Text>
          {info.row.original.customerAddress || '-'}
        </Text>
      ),
    }),
    columnHelper.accessor('customerPhone', {
      id: 'customerPhone',
      header: () => (
        <Text
          justifyContent="space-between"
          align="center"
          fontSize={{ sm: '10px', lg: '12px' }}
          color="gray.400"
        >
          电话
        </Text>
      ),
      cell: (info) => (
        <Text>
          {info.row.original.customerPhone || '-'}
        </Text>
      ),
    }),
    columnHelper.accessor('bankName', {
      id: 'bankName',
      header: () => (
        <Text
        >
          开户银行名称
        </Text>
      ),
      cell: (info) => (
        <Text>
          {info.row.original.bankName || '-'}
        </Text>
      ),
    }),
    columnHelper.accessor('bankAccount', {
      id: 'bankAccount',
      header: () => (
        <Text
        >
          银行帐户
        </Text>
      ),
      cell: (info) => (
        <Text>
          {info.row.original.bankAccount || '-'}
        </Text>
      ),
    }),
    columnHelper.accessor('opt', {
      id: 'opt',
      header: () => (
        <Text
          justifyContent="space-between"
          align="center"
          fontSize={{ sm: '10px', lg: '12px' }}
          color="gray.400"
        >
          操作
        </Text>
      ),
      cell: (info) => (
        info.row.original.link ? <Link href={info.row.original.link} color="brand.500" download target="_blank">下载发票</Link> : '-'
      ),
    }),
  ];
  const [data, setData] = React.useState(() => []);
  const table = useReactTable({
    data,
    columns,
    state: {
      sorting,
    },
    onSortingChange: setSorting,
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
    debugTable: true,
  });

  
  const itemsPerPage = 4
  const [itemOffset, setItemOffset] = React.useState(0);

  const [pageNumber, setPageNumber] = React.useState(1);
  const [pageCount, setPageCount] = React.useState(1);

  // Invoke when user click to request another page.
  const handlePageClick = (event) => {
    setPageNumber(event.selected + 1)
  };

  React.useEffect(() => {
    commonFetch({
      url: '/api/invoice/page',
      method: 'get',
      params: {
        pageNumber: pageNumber,
        pageSize: 10
      }
    }, toast).then(res => {
      setData(res.records)
      setPageCount(Math.ceil(res.total / 10))
    })
  }, [pageNumber, props.refreshCount])

  return (
    <Card
      flexDirection="column"
      w="100%"
      px="0px"
      overflowX={{ sm: 'scroll', lg: 'hidden' }}
    >
      {/* <Flex px="25px" mb="8px" justifyContent="space-between" align="center">
        <Text
          color={textColor}
          fontSize="22px"
          mb="4px"
          fontWeight="700"
          lineHeight="100%"
        >
          4-Columns Table
        </Text>
        <Menu />
      </Flex> */}
      {data.length ? (
        <Box>
          <Table variant="simple" color="gray.500" mb="24px" mt="12px">
            <Thead>
              {table.getHeaderGroups().map((headerGroup) => (
                <Tr key={headerGroup.id}>
                  {headerGroup.headers.map((header) => {
                    return (
                      <Th
                        key={header.id}
                        colSpan={header.colSpan}
                        pe="10px"
                        borderColor={borderColor}
                        cursor="pointer"
                        onClick={header.column.getToggleSortingHandler()}
                      >
                        <Flex
                          justifyContent="space-between"
                          align="center"
                          fontSize={{ sm: '10px', lg: '12px' }}
                          color="gray.400"
                        >
                          {flexRender(
                            header.column.columnDef.header,
                            header.getContext(),
                          )}
                          {{
                            asc: '',
                            desc: '',
                          }[header.column.getIsSorted()] ?? null}
                        </Flex>
                      </Th>
                    );
                  })}
                </Tr>
              ))}
            </Thead>
            <Tbody>
              {table
                .getRowModel()
                .rows.slice(0, 11)
                .map((row) => {
                  return (
                    <Tr key={row.id}>
                      {row.getVisibleCells().map((cell) => {
                        return (
                          <Td
                            key={cell.id}
                            fontSize={{ sm: '14px' }}
                            minW={{ sm: '150px', md: '200px', lg: 'auto' }}
                            borderColor="transparent"
                          >
                            {flexRender(
                              cell.column.columnDef.cell,
                              cell.getContext(),
                            )}
                          </Td>
                        );
                      })}
                    </Tr>
                  );
                })}
            </Tbody>
          </Table>
          <Flex mt="-20px" mr="30px" justifyContent={'flex-end'}>
            <ReactPaginate
              breakLabel="..."
              nextLabel=">"
              onPageChange={handlePageClick}
              pageRangeDisplayed={5}
              pageCount={pageCount}
              previousLabel="<"
              renderOnZeroPageCount={null}
              pageClassName="page-item"
              pageLinkClassName="page-link"
              previousClassName="page-item"
              previousLinkClassName="page-link"
              nextClassName="page-item"
              nextLinkClassName="page-link"
              breakClassName="page-item"
              breakLinkClassName="page-link"
              containerClassName="pagination"
              activeClassName="active"
            />
          </Flex>
        </Box>
      ) : (
        <>
          <Table variant="simple" color="gray.500" mb="24px" mt="12px">
            <Thead>
              {table.getHeaderGroups().map((headerGroup) => (
                <Tr key={headerGroup.id}>
                  {headerGroup.headers.map((header) => {
                    return (
                      <Th
                        key={header.id}
                        colSpan={header.colSpan}
                        pe="10px"
                        borderColor={borderColor}
                        cursor="pointer"
                        onClick={header.column.getToggleSortingHandler()}
                      >
                        <Flex
                          justifyContent="space-between"
                          align="center"
                          fontSize={{ sm: '10px', lg: '12px' }}
                          color="gray.400"
                        >
                          {flexRender(
                            header.column.columnDef.header,
                            header.getContext(),
                          )}
                          {{
                            asc: '',
                            desc: '',
                          }[header.column.getIsSorted()] ?? null}
                        </Flex>
                      </Th>
                    );
                  })}
                </Tr>
              ))}
            </Thead>
          </Table>
          <Flex height={"200px"} justify={"center"} align={"center"}>
            <Text color={'gray.500'} fontSize={"18px"}>暂无数据</Text>
          </Flex>
        </>
      )}
    </Card>
  );
}
